import React, { useState, useEffect, useMemo } from "react";
import { MdDeleteOutline } from "react-icons/md";
import { FaCheck } from "react-icons/fa";
import { TbEdit,TbEye } from "react-icons/tb";
import AddUser from "./Assets/AddForm";
import EditForm from "./Assets/EditForm";
import DeleteUser from "./Assets/DeleteModal";
import ApproveUser from "./Assets/ApproveModel";
import { toast } from "react-toastify";

const UserDetails = () => {
  const [formData, setFormData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [addUserModel, setAddUserModel] = useState(false);
  const [editFormModel, setEditFormModel] = useState(false);
  const [itemToEdit, setItemToEdit] = useState(null);
  const [itemToView, setItemToView] = useState(null);
  const [approveModalShow, setApproveModalShow] = useState(false);
  const [itemToApprove, setItemToApprove] = useState(null);

  const itemsPerPage = 20;

  const Auth = localStorage.getItem("authToken");
    const userRole = localStorage.getItem("UserRole");

  useEffect(() => {
    fetchFormData();
  }, []);
  // fetch the all data
  const fetchFormData = async () => {
    try {
      const response = await fetch("https://support.ace-school-backend.serverscripts.in/api/v1/admin/school-form/view", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`
        },
      });

      
      
      const result = await response.json();
      if (!result.success) throw new Error("Failed to fetch form data");
      setFormData(result.data || []);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  
  const filteredFormData = useMemo(() => {
    const today = new Date();
    let filtered = formData.filter((u) => {
      const nameMatch = u.name?.toLowerCase().includes(search.toLowerCase()) || u.schoolName?.toLowerCase().includes(search.toLowerCase());
      

      return nameMatch ;
    });

    
    

    return filtered;
  }, [formData, search]);

  // Pagination Method
  const totalPages = Math.ceil(filteredFormData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentFormData = filteredFormData.slice(startIndex, startIndex + itemsPerPage);

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  const handleAddUserClick = () => {
    setAddUserModel(true);
  };

  const cancelAddUser = () => {
    setAddUserModel(false);
  };
  
    const confirmAddUser = async (formData) => {
    try {
      
      const response = await fetch("https://support.ace-school-backend.serverscripts.in/api/v1/admin/school-form/add", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`
        },
        body: JSON.stringify(formData),  
      });

      const result = await response.json();
      if (!result.success) {
        toast.error(result.message || "Delete failed");
        return;
      }
      toast.success(result.message);
    } catch (error) {
    }
    fetchFormData();
    setAddUserModel(false);
  };

  const handleEditFormClick = (user) => {
    setItemToEdit(user);
    setEditFormModel(true);
  };

  const cancelEditForm = () => {
    setEditFormModel(false);
    setItemToEdit(null);
  };

  const confirmEditForm = async (formData) => {
    try {

      const response = await fetch(`https://support.ace-school-backend.serverscripts.in/api/v1/admin/school-form/edit/${formData.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`,
        },
        body: JSON.stringify(formData), 
      });

      const errorText = await response.json();
      if (!errorText.success) {
        
        toast.error(errorText.message || "User Updated Successfully");
        throw new Error(`Failed to save user: ${errorText}`);
      }else{
        toast.success(errorText.message || "User Updated Successfully");
      }
    } catch (error) {
      //console.error("Something went wrong");
    }
    fetchFormData();
    setEditFormModel(false);
    setItemToEdit(null);
  };

  const handleDeleteClick = (id) => {
    setItemToDelete(id);
    setDeleteModalShow(true);
  };

  const confirmDelete = async () => {
    try {


      const response = await fetch(`https://support.ace-school-backend.serverscripts.in/api/v1/admin/school-form/delete/${itemToDelete}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`
        }  
      });

      const errorText = await response.json();
      if (!errorText.success) {

        toast.error(`${errorText.message} (Tasks: ${errorText.task_count}, Logs: ${errorText.log_count})` || "Failed to delete user");
        throw new Error(`Failed to delete user: ${errorText}`);
      }else{
        toast.success(errorText.message || "User deleted successfully");
      }
    } catch (error) {
      //console.error("Something went wrong");
    }
    fetchFormData();
    setDeleteModalShow(false);
    setItemToDelete(null);
  };

  const cancelDelete = () => {
    setDeleteModalShow(false);
    setItemToDelete(null);
  };



  const handleApproveClick = (id) => {
    setItemToApprove(id);
    setApproveModalShow(true);
  };

  const confirmApprove = async (formData) => {
    try {

      console.log("Approving with data:", formData);
      const response = await fetch(`https://support.ace-school-backend.serverscripts.in/api/v1/admin/school/approve/${itemToApprove}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`
        },  
        body: JSON.stringify(formData),
      });

      const errorText = await response.json();
      console.log("Approve response:", errorText);
      if (!errorText.success) {

        toast.error(`${errorText.message} (Tasks: ${errorText.task_count}, Logs: ${errorText.log_count})` || "Failed to delete user");
        throw new Error(`Failed to delete user: ${errorText}`);
      }else{
        toast.success(errorText.message || "User deleted successfully");
      }
    } catch (error) {
      console.log("Something went wrong");
    }
    fetchFormData();
    setApproveModalShow(false);
    setItemToApprove(null);
  };

  const cancelApprove = () => {
    setApproveModalShow(false);
    setItemToApprove(null);
  };



  return (
    <div className="Task-Details-Container">
      <h2 className="text-xl font-semibold mb-4">School Create Form</h2>
      <div className="flex justify-between items-center mb-4">
        <div className="user-heading">
          <button className="text-sm font-normal bg-blue-500 p-2 rounded text-white cursor-pointer" onClick={() => handleAddUserClick()}>Fill New Form</button>
        </div>
      
        <div className="flex justify-end flex-wrap gap-4 mb-4">
          <input
            type="text"
            placeholder="Search by user name..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(1);
            }}
            className="px-4 py-2 border rounded"
          />
          

          
        </div>
      </div>

      
      <table className="w-full text-sm border user-table">
        <thead className="bg-gray-100">
          <tr>
            <th className="px-4 py-2 text-left">#</th>
            <th className="px-4 py-2 text-left">User Name</th>
            <th className="px-4 py-2 text-left">School Name</th>
            <th className="px-4 py-2 text-left">School Address</th>
            <th className="px-4 py-2 text-left">Email</th>
            <th className="px-4 py-2 text-left">Action</th>
          </tr>
        </thead>
        <tbody>
          {currentFormData.length > 0 ? (
            currentFormData.map((f, index) => (
              <tr key={f.id || index} className="border-t">
                <td className="px-4 py-2">{startIndex + index + 1}</td>
                <td className="px-4 py-2"><div className="flex items-center space-x-2">{f.name || "N/A"}</div></td>
                <td className="px-4 py-2">{f.schoolName || "N/A"}</td>
                <td className="px-4 py-2"> {f.city + ", " + f.state + " - " + f.pincode || "N/A"}</td>
                <td className="px-4 py-2">{f.email || "N/A"}</td>
                <td className="px-4 py-2 flex gap-2">
                  {Number(userRole) <= 2 && (
                    <button className="text-blue-500 hover:text-blue-700" onClick={() => handleApproveClick(f.id)}>
                      <FaCheck size={22}  />
                    </button>
                  )}
                  <button className="text-blue-500 hover:text-blue-700" onClick={() => handleEditFormClick(f)}>
                    <TbEdit size={22} />
                  </button>
                  <button className="text-red-500 hover:text-red-700" onClick={() => handleDeleteClick(f.id)}>
                    <MdDeleteOutline size={22} />
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center py-4 text-gray-500">
                No form data found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      
      <div className="flex justify-center mt-4 gap-2 items-center">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={currentPage === 1}
        >
          Prev
        </button>

        <span className="ml-4 text-sm text-gray-600">
          Page {currentPage} / {totalPages || 1}
        </span>

        <button
          onClick={() => handlePageChange(currentPage + 1)}
          className="px-3 py-1 border rounded disabled:opacity-50"
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
      {addUserModel && (
        <AddUser
          
          onClose={cancelAddUser}
          onSubmit={(formData) => confirmAddUser(formData)}
        />
      )}
      {editFormModel && (
        <EditForm
          user={itemToEdit}
          onClose={cancelEditForm}
          onEdit={(formData) => confirmEditForm(formData)}
        />
      )}

      {deleteModalShow && (
        <DeleteUser
          itemName={
            currentFormData.find((p) => p.id === itemToDelete)?.name || "Unknown Form Data"
          }
          onClose={cancelDelete}
          onDelete={confirmDelete}
        />
      )}
      {approveModalShow && (
        <ApproveUser
          itemName={
            currentFormData.find((p) => p.id === itemToApprove)?.schoolName || "Unknown Form Data"
          }
          onClose={cancelApprove}
          onApprove={(formData) => confirmApprove(formData)}
        />
      )}

      
    </div>
  );
};

export default UserDetails;


const formatDateTime = (value) => {
  if (!value) return "";
  const date = new Date(value);
  return isNaN(date.getTime()) ? "" : date.toLocaleString();
};
